// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__gjs5Z","heading":"faq_heading__E2BTJ","subheading":"faq_subheading__ja9ms","accordionContainer":"faq_accordionContainer__BCkOC"};